
export class RulePredicateConfigurationModel {
  conditions: { [key: string]: string };
  exceptions: { [key: string]: string };
}
